<template>
    <div class="FM_withdrawalList">
        <!-- 代理提现 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="withdrawalForm" class="demo-form-inline">
                <el-form-item style="width:177px;" v-if="level > 0">
                    <el-radio v-model="withdrawalForm.team_type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="withdrawalForm.team_type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
<!--                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="withdrawalForm.real_name"
                        placeholder="请输入代理姓名"
                    ></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-input size clearable v-model="withdrawalForm.phone" placeholder="请输入代理账户"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input size clearable v-model="withdrawalForm.agent_no" placeholder="请输入代理编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="withdrawalForm.withdraw_type" clearable placeholder="出款类型">
                        <el-option label="对私" value="1"></el-option>
						<el-option label="对公" value="2"></el-option>

                    </el-select>
                </el-form-item>
				<el-form-item>
				    <el-select size v-model="withdrawalForm.status" clearable placeholder="请选择当前状态">
				        <el-option label="未审核" value="0"></el-option>
						<el-option label="提现审核通过" value="4"></el-option>
					    <el-option label="等待结果" value="3"></el-option>
				        <el-option label="审核拒绝" value="2"></el-option>
						 <el-option label="出款成功" value="1"></el-option>
						 <el-option label="出款失败" value="6"></el-option>
				
				    </el-select>
				</el-form-item>
                <!-- <el-form-item>
                    <el-select size v-model="withdrawalForm.type" clearable placeholder="请选择结算方式">
                        <el-option label="线下付款" value="1"></el-option>
                        <el-option label="平台提现" value="4"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-date-picker
                        v-model="creatDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="代理申请开始日期"
                        end-placeholder="代理申请结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="creatDateChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="auditDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="审核开始日期"
                        end-placeholder="审核结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="auditDateChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(withdrawalForm)"
                    >查询</el-button>
					<el-button
					     size="small"
					     type="primary"
					     icon="el-icon-download"
					     @click="handleDownLoad(withdrawalForm)"
					 >导出</el-button>
					 <el-button
							v-if="level == 0"
					      size="small"
					      type="primary"
					      icon="el-icon-bank-card"
					      @click="batchPaid"
					  >批量审核</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 15px;display: flex;">
			    <div class="tableTitle">
			        <span>云账户余额：</span>
			        <span>{{total_balance}}</span>
			    </div>
				<div class="tableTitle"  style="margin-left: 50px;">
				    <span>到账总额：</span>
				    <span>{{sum}}</span>
				</div>
			</div>
            <el-table
                :data="withdrawalTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
				@selection-change="selectChange"
            >
				<el-table-column
                    fixed
                    label="ID"
                    align="center"
                    min-width="80"
                    type="selection"
                    header-align="center"
                ></el-table-column>

				<el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>

                <!-- 机构 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_name"
                    label="机构"
                    min-width="200"
                ></el-table-column>
				<!-- 代理姓名 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="agent_no"
				    label="代理编号"
				    min-width="150"
				></el-table-column>
                <!-- 代理姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="代理姓名"
                    min-width="150"
                ></el-table-column>
                <!-- 代理账户 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="代理账户"
                    min-width="100"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
				<!-- 出款人 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="account_name"
				    label="收款账户"
				    min-width="150"
				></el-table-column>
                <!-- 卡号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_code"
                    label="卡号"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.bank_code | desIdCard" placement="top">
                      <p>{{ scope.row.bank_code | desIdCard }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 提现金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="money"
                    label="提现金额"
                    min-width="110"
                ></el-table-column>
                <!-- 代收税点 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="fee_money"
                    label="代收税点"
                    min-width="80"
                ></el-table-column>
                <!-- 出款服务费 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="service_fee"
                    label="出款服务费"
                    min-width="90"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.service_fee == 0? '--':scope.row.service_fee}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_personal_tax"
                    label="预扣个税"
                    min-width="90"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.user_personal_tax == 0? '--':scope.row.user_personal_tax}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_value_added_tax"
                    label="预扣增值税"
                    min-width="90"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.user_value_added_tax == 0? '--':scope.row.user_value_added_tax}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_additional_tax"
                    label="预扣附加税"
                    min-width="90"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.user_additional_tax == 0? '--':scope.row.user_additional_tax}}</span>
                    </template>
                </el-table-column>
                <!-- 税率扣点 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="id_card"
                    label="税率扣点"
                    min-width="220"
                ></el-table-column>-->
                <!-- 税票抵扣 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="税票抵扣"
                    min-width="150"
                ></el-table-column>-->
                <!-- 结算金额 -->
<!--                <el-table-column
                    header-align="center"
                    align="center"
                    prop="true_money"
                    label="核心传值"
                    min-width="150"
                ></el-table-column> -->
                <!-- 结算金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="true_money"
                    label="实际到账"
                    min-width="110"
                ></el-table-column>
                <!-- 提现费用 -->
<!--                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pay_fee"
                    label="提现费用"
                    min-width="120"
                ></el-table-column> -->
                <!-- 当前状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status"
                    label="当前状态"
                    min-width="80"
                    :formatter="formatStatus"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="remark"
				    label="备注"
				    min-width="160"
				></el-table-column>
                <!-- 结算方式 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="start_type"
                    label="用户提交账号"
                    min-width="100"
                    :formatter="formatstartType"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="withdraw_type_name"
				    label="出款类型"
				    min-width="80"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="is_invoice_name"
				    label="开票"
				    min-width="80"
				></el-table-column>
                <!-- 结算方式 -->
<!--                <el-table-column
                    header-align="center"
                    align="center"
                    prop="type"
                    label="核心出款账号"
                    min-width="120"
                    :formatter="formatType"
                ></el-table-column> -->
                <!-- 申请时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="申请时间"
                    min-width="150"
                ></el-table-column>
                <!-- 审核时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="audit_time"
                    label="审核时间"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
               <el-table-column v-if="level==0"
                   header-align="center"
                   align="center"
                   fixed="right"
                   label="操作"
                   min-width="150"
               >
                   <template slot-scope="scope">
<!--                       <el-button
                           @click="handleInfo(scope.row)"
                           type="text"
                           size="small"
                           slot="reference"
                           v-if="level == 0"
                       >详情</el-button>&nbsp; -->
                       <!-- &lt;!&ndash; 撤销验证 &ndash;&gt; -->
                       <el-button
                           type="text"
                           size="small"
                           slot="reference"
                           @click="handleUndo(scope.row)"
                           v-if="level == 0 && (scope.row.status == 0 || scope.row.status == 5)"
                       >审核</el-button>
                   </template>
               </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <!-- 批量支付弹窗 -->
        <el-dialog :visible.sync="batchDialog" width="430px">
            <div class="batchTitle">
                <span>付款金额：</span>
                <span>{{batchInfo.payMoney.toFixed(2)}}&nbsp;元</span>
            </div>
            <div class="batchTitle">
                <span>付款笔数：</span>
                <span>{{batchInfo.payNum}}&nbsp;笔</span>
            </div>
            <div  v-if="pay_channel == 3"  class="batchTitle">
                <span>选择签约服务商：</span>
                <el-select @change="selChange"  v-model="service_company_id" clearable>
                	<el-option v-for="item in channelList" :label="item.service_company_name" :value="item.service_company_id"
                		:key="item.service_company_name"></el-option>
                </el-select>
            </div>
            
<!--            <div class="batchTitle">
                <span>付款费用：</span>
                <span>{{batchInfo.payCost.toFixed(2)}}&nbsp;元</span>
            </div> -->
            <el-divider></el-divider>
<!--            <div class="batchTitle">
                <span>提现账户余额：</span>
                <span>{{batchInfo.payBalance}}&nbsp;元</span>
                <span class="batchTitle" style="margin-left:10px;">
                    <span>所需费用：</span>
                    <span>{{batchInfo.payCount.toFixed(2)}}&nbsp;元</span>
                </span>
            </div> -->
            <el-button
                type="primary"
                @click="submitBatch"
                size="small"
                :disabled="batchInfo.payButton"
            >确 定</el-button>
            <el-button @click="batchDialog = false" size="small">取 消</el-button>
        </el-dialog>
        <!-- 审核&详情 -->
        <info-audit
            v-if="infoIsShow"
            :infoIsShow="infoIsShow"
            :dialogData="dialogData"
            @infoClose="infoClose"
        ></info-audit>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
import infoAudit from './FM_withdrawalInfo';
export default {
    name: "FM_withdrawalList",
    data() {
        return {
			total_balance:0,//云账户余额
            level: sessionStorage.getItem('level'),
            isShowBatchPay: 0, //是否设置提现通道：0=否，1=是
            sum: 0, //是否设置提现通道：0=否，1=是
            payRate: 0.071, //提现费率
            creatDate: '', //申请时间范围
            auditDate: '', //审核时间范围
            batchDialog: false, //批量提现弹窗
            infoIsShow: false, //审核弹窗
            dialogData: {
                isInfo: null, //弹窗类型 1.详情 2.审核
                data: {} //当前行的数据
            },
            batchList: [], //批量支付数据源
            batchInfo: {
                batchReqData: [], //请求的id
                payMoney: 0, //付款金额
                payNum: 0, //付款笔数
                payCost: 0, //付款费用
                payBalance: 0, //提现账户余额
                payCount: 0, //所需费用
                payButton: false
            },
            withdrawalTable: [], //表格
            withdrawalForm: {
                phone: '', //代理账号
                agent_no: '', //代理编号
                real_name: '',   //代理真实姓名
                withdraw_type: '',// 结算方式
                status: '',//当前状态
                start_create_time: '',    //申请开始时间
                end_create_time: '',    //申请结束时间
                start_audit_time: '',  //审核开始时间
                end_audit_time: '',  //审核结束时间
                page: 1,
                limit: 10,
                team_type:1
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false ,//导出loading
            channelList: [],
            pay_channel: [],
            contract_code:'',
            service_company_id:""
        }
    },
    mounted() {
        this.getData( //初始化
            this.withdrawalForm
        );
        this.$api.post('user/withdraw_list', {}, res => {
            if (res.code == 0) {
                
               this.channelList = res.data.contract_list
               
                this.pay_channel =  res.data.pay_channel
        
            } else {
                this.$message.error(res.msg);
             
            }
        });
    },
    components: {
        paginations,
        infoAudit
    },
    methods: {
        selChange(e) {
            for (let item of this.channelList) {
                if (item.service_company_id == e) {
                    this.contract_code = item.contract_code
                }
            }
        },
        typeChange(val) { //监听radio
            this.withdrawalForm.team_type = val;
            this.currentPage = 1; //重置分页
            this.withdrawalForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        handleSearch(withdrawalForm) {
            this.withdrawalForm.page = 1;
            this.page.currentPage = 1;
            // 表单提交
            this.getData();
        },
		handleDownLoad(searchForm) { //导出
		    this.downLoading = true;
		    this.$api.post("user/withdraw_list_down", searchForm, res => {
		        if (res.code == 0) {
		            this.$message.success(res.msg);
		            var link=this.$file_url+res.data;
		            window.open(link)
		        } else {
		            this.$message.error(res.msg);
		        }
		        //渲染结束后取消加载
		        this.downLoading = false;
		    })
		},
        // handleDownLoad() { //导出
        //     let handleExportExcel = this.common.handleExportExcel;
        //     this.downLoading = true;
        //     let searchVal = this._.omit(this.withdrawalForm, ['page', 'limit']);
        //     let value = {};
        //     this._.forEach(searchVal, (item, index) => {
        //         if (item != '') {
        //             value[index] = item;
        //         }
        //     });
        //     handleExportExcel({ type: 1, value: JSON.stringify(value) }).then(() => {
        //         this.downLoading = false;
        //     });
        // },
        handleInfo(row) { //详情
            this.infoIsShow = true;
            this.dialogData.isInfo = 1;
            this.dialogData.data = row;
        },
        handleUndo(row) { //审核
            this.infoIsShow = true;
            this.dialogData.isInfo = 2;
            this.dialogData.data = row;
            this.dialogData.data.isShowPayMethods = this.isShowBatchPay;
        },
        batchPaid() { //批量提现
            let batchData = this.batchList;
            if (batchData.length != 0) {
                let flag = true;
                this._.forEach(batchData, item => {
                    if (item.status != 0) {
                        this.$message.error('如需批量提现，“当前状态”需筛选成“未审核”状态');
                        flag = false;
                        return false;
                    }
                });
                if (flag) {
                    //重置
                    this.batchInfo.batchReqData = [];
                    this.batchInfo.payMoney = 0;
                    this.batchInfo.payNum = 0;
                    this.batchInfo.payCost = 0;
                    this.batchInfo.payBalance = 0;
                    this.batchInfo.payCount = 0;
                    //赋值
                    this._.forEach(batchData, item => {
                        this.batchInfo.batchReqData.push(item.id); //请求的数据
                        this.batchInfo.payMoney = this.batchInfo.payMoney + Number(item.true_money); //付款金额
                    });
                    this.batchInfo.payNum = batchData.length; //付款笔数
                    this.batchInfo.payCost = this.batchInfo.payMoney * this.payRate;  //付款费用
                    this.batchInfo.payCount = this.batchInfo.payMoney + this.batchInfo.payCost;  //所需费用
                    this.batchDialog = true; //弹窗
                    //获取提现账户余额
                    // this.$api.post('organization/getBalance', {}, res => {
                    //     if (res.code == 0) {
                    //         this.batchInfo.payBalance = res.data.payment_balance;
                    //         if (this.batchInfo.payCount > this.batchInfo.payBalance) {
                    //             this.batchInfo.payButton = true; //所需费用大于余额禁用
                    //         } else {
                    //             this.batchInfo.payButton = false;
                    //         }
                    //     } else {
                    //         this.$message.error(res.msg);
                    //     }
                    // })
                }
            } else {
                this.$message.error('请先选择批量提现数据');
            }
        },
        submitBatch() { //提交批量提现
            if (this.pay_channel == 3 && this.service_company_id.length == 0) {
                this.$message.error({
                    type: 'error',
                    message: '请选择签约服务商!',
                    duration: 2000,
                });
                
                return
            }
            this.$api.post('user/withdrawAuditBatch', { ids: this.batchInfo.batchReqData, pay_channel:this.pay_channel, contract_code:this.contract_code, service_company_id:this.service_company_id}, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    this.batchDialog = false;
                    this.getData(this.withdrawalForm);
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        infoClose(ref) {
            this.infoIsShow = false;
            if (ref) {
                this.getData();//刷新
            }
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.withdrawalForm.page = this.page.currentPage;
            this.withdrawalForm.limit = this.page.pageSize;
            this.getData();
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.withdrawalForm.page = this.page.currentPage;
            this.withdrawalForm.limit = limit;
            this.getData();
        },
        getData() { //获取列表
            this.loading = true;
            this.$api.post("user/withdraw_list",this.withdrawalForm,res => {
                if (res.code == 0) {
					this.yzh();
                    let data = res.data;
                    this.page.total = data.count; //总数
                    this.sum = data.sum; //总数
                    this.withdrawalTable = data.list;
					console.log(this.withdrawalTable)
                    this.payRate = Number(data.rate);
                    this.isShowBatchPay = data.is_payment_account;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
		//云账户余额
		yzh() { //获取列表
		    this.$api.post("yzh/get_account",{},res => {
		        if (res.code == 0) {
		            let data = res.data;
		            this.total_balance = data.total_balance; 
		        }
		    })
		},
        selectChange(val) { //多选发生改变时
            this.batchList = val;
        },
        formatStatus(row) { //格式化当前状态
            var status = '';
            switch (row.status) {
                case 0:
                    status = '未审核';
                    break;
                case 1:
                    status = '出款成功';
                    break;
                case 2:
                    status = '审核拒绝';
                    break;
                case 3:
					status = '等待结果';
					break;
                case 4:
                    status = '审核通过-未出款';
                    break;
				case 6:
					status = '出款失败';
					break;
                default:
                    status = '提现失败';
                    break;
            }
            return status;
        },
    //     formatType(row) { //格式化结算方式
    //         var type = '';
    //         switch (row.account_type) {
    //             case 0:
    //                 type = '分润账户';
    //                 break;
    //             case 1:
    //                 type = '活动账户';
    //                 break;
				// case 2:
				// 	type = '押金账户';
				// 	break;
    //         }
    //         return type;
    //     },
        formatstartType(row) { //格式化结算方式
            var start_type = '';
            switch (row.start_account_type) {
                case 0:
                    start_type = '分润账户';
                    break;
                case 1:
                    start_type = '达标返现账户';
                    break;
				case 2:
					start_type = '押金账户';
					break;
				case 5:
					start_type = '特惠奖励账户';
					break;
                case 6:
                	start_type = '大盘分红账户';
                	break;
                case 7:
                	start_type = '管理奖账户';
                	break;
                case 8:
                	start_type = '底薪奖账户';
                	break;
                case 9:
                	start_type = '流量卡账户';
                	break;
                // case 0:
                //     type = '- -';
                //     break;
                // case 1:
                //     type = '线下支付';
                //     break;
                // case 2:
                //     type = '微信支付';
                //     break;
                // case 3:
                //     type = '支付宝支付';
                //     break;
                // default:
                //     type = '平台支付';
                //     break;
            }
            return start_type;
        },
        
        creatDateChange(DateArr) { //申请时间
            this.withdrawalForm.start_create_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.withdrawalForm.end_create_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
        auditDateChange(DateArr) { //审核时间
            this.withdrawalForm.start_audit_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.withdrawalForm.end_audit_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        }
    }
};
</script>

<style lang="scss" scope>
.FM_withdrawalList {
    .batchTitle {
        font-size: 12px;
        margin: 20px 0;
        :nth-child(1) {
            font-weight: 700;
            color: #1e1e1e;
        }
    }
    // .el-dialog__header {
    //     padding: 20px 20px 0px;
    // }
    .el-dialog__body {
        padding: 0px 20px 30px 20px;
    }
    // .el-input__inner {
    //     font-size: 12px;
    // }
    // .el-form-item {
    //     margin-bottom: 5px;
    // }
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
}
</style>
